import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/video/smartvideo.mp4'


const _withScopeId = n => (_pushScopeId("data-v-58a30aa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container",
  style: {"background":"#fff"}
}
const _hoisted_2 = { class: "data-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "门店经营数据", -1))
const _hoisted_4 = { class: "data-box-list" }
const _hoisted_5 = { class: "data-box-img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 上座率 ")
const _hoisted_8 = { class: "data-box-img" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 翻台率 ")
const _hoisted_11 = { class: "data-box-img" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 餐位利用率 ")
const _hoisted_14 = { class: "data-box-img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 点单时长 ")
const _hoisted_17 = { class: "data-box-img" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 就餐时长 ")
const _hoisted_20 = { class: "data-box-img" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 上锅时效 ")
const _hoisted_23 = { class: "data-box-img" }
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 清台时效 ")
const _hoisted_26 = { class: "ai" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "基于视频AI计算", -1))
const _hoisted_28 = { class: "ai-box" }
const _hoisted_29 = ["poster"]
const _hoisted_30 = { class: "introduce" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "数据分析介绍", -1))
const _hoisted_32 = { class: "introduce-list" }
const _hoisted_33 = { style: { backgroundColor: '#FEF5E3', color: '#F7BB42' } }
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dl", null, [
  /*#__PURE__*/_createElementVNode("dt", null, "上座率"),
  /*#__PURE__*/_createElementVNode("dd", null, " 上座率是指一个餐厅每餐约接待人次和每餐可利用的餐位数之间的比率。 ")
], -1))
const _hoisted_36 = { style: { backgroundColor: '#FEE0EA', color: '#F7BB42' } }
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dl", null, [
  /*#__PURE__*/_createElementVNode("dt", null, "翻台率"),
  /*#__PURE__*/_createElementVNode("dd", null, " 翻台率高，意味着能在有限的空间和有限的营业时间内，让座位的流动率提高。 ")
], -1))
const _hoisted_39 = ["src"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dl", null, [
  /*#__PURE__*/_createElementVNode("dt", null, "餐位利用率"),
  /*#__PURE__*/_createElementVNode("dd", null, " 餐位利用率是指一个餐厅每天的接待人次和餐位数量的比率，餐位利用率反映日均座位周转次数。 ")
], -1))
const _hoisted_41 = ["src"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dl", null, [
  /*#__PURE__*/_createElementVNode("dt", null, "点单时长"),
  /*#__PURE__*/_createElementVNode("dd", null, " 顾客落座之后点单到下单成功的时长记录统计。改善顾客点菜形式、员工对菜品的介绍等等问题，预判员工的快速下单。 ")
], -1))
const _hoisted_43 = ["src"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dl", null, [
  /*#__PURE__*/_createElementVNode("dt", null, "就餐时长"),
  /*#__PURE__*/_createElementVNode("dd", null, " 就餐开始到结束的时长记录，对每一餐桌的就餐时长记录，可以与翻台率进行关联分析。 ")
], -1))
const _hoisted_45 = ["src"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dl", null, [
  /*#__PURE__*/_createElementVNode("dt", null, "上锅时效"),
  /*#__PURE__*/_createElementVNode("dd", null, " 顾客下单成功到上锅之前的时长记录统计，若时长太久，改善问题菜品不足、员工人手不足，尤其是对高峰期来说。 ")
], -1))
const _hoisted_47 = ["src"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dl", null, [
  /*#__PURE__*/_createElementVNode("dt", null, "清台时效"),
  /*#__PURE__*/_createElementVNode("dd", null, " 顾客就餐结束，确认顾客已离桌后对清台时长的记录，若时间过长，改善高峰期排队等待就餐时间、清台效率等。 ")
], -1))

import ComHeader from '../../components/ComHeader/index.vue'
import { useStore } from 'vuex'
import { Toast } from 'vant'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const show = () => {
  Toast.fail('此功能暂未开放')
}

const store = useStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ComHeader, {
      height: 16,
      title: "门店经营分析"
    }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", { onClick: show }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x.png')
            }, null, 8, _hoisted_6)
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", { onClick: show }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x(1).png')
            }, null, 8, _hoisted_9)
          ]),
          _hoisted_10
        ]),
        _createElementVNode("div", { onClick: show }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x(2).png')
            }, null, 8, _hoisted_12)
          ]),
          _hoisted_13
        ]),
        _createElementVNode("div", { onClick: show }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x(3).png')
            }, null, 8, _hoisted_15)
          ]),
          _hoisted_16
        ]),
        _createElementVNode("div", { onClick: show }, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x(4).png')
            }, null, 8, _hoisted_18)
          ]),
          _hoisted_19
        ]),
        _createElementVNode("div", { onClick: show }, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x(5).png')
            }, null, 8, _hoisted_21)
          ]),
          _hoisted_22
        ]),
        _createElementVNode("div", { onClick: show }, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x(6).png')
            }, null, 8, _hoisted_24)
          ]),
          _hoisted_25
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("video", {
          controls: "",
          loop: "",
          src: _imports_0,
          poster: require('@/assets/video/poster.png')
        }, null, 8, _hoisted_29)
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("ul", _hoisted_32, [
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x.png')
            }, null, 8, _hoisted_34)
          ]),
          _hoisted_35
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x(1).png')
            }, null, 8, _hoisted_37)
          ]),
          _hoisted_38
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", {
            style: _normalizeStyle({ backgroundColor: 'rgb(230,248,226)', color: '#F63272' })
          }, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x(2).png')
            }, null, 8, _hoisted_39)
          ], 4),
          _hoisted_40
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", {
            style: _normalizeStyle({ backgroundColor: 'rgb(226,239,254)', color: '#F63272' })
          }, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x(3).png')
            }, null, 8, _hoisted_41)
          ], 4),
          _hoisted_42
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", {
            style: _normalizeStyle({ backgroundColor: 'rgb(238,233,254)', color: '#F63272' })
          }, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x(4).png')
            }, null, 8, _hoisted_43)
          ], 4),
          _hoisted_44
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", {
            style: _normalizeStyle({ backgroundColor: 'rgb(254,245,227)', color: '#F63272' })
          }, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x(5).png')
            }, null, 8, _hoisted_45)
          ], 4),
          _hoisted_46
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", {
            style: _normalizeStyle({ backgroundColor: 'rgb(254,224,234)', color: '#F63272' })
          }, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/icon@2x(6).png')
            }, null, 8, _hoisted_47)
          ], 4),
          _hoisted_48
        ])
      ])
    ])
  ]))
}
}

})